/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserQueryVariables = Types.Exact<{
  id: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetUserQuery = { __typename: 'Query', getUser: { __typename: 'User', email: string, first_name: string, last_name: string, id: string, label_id: string | null, space_id: string | null, unit_id: string | null, country_code: string, is_external: boolean, role: { __typename: 'UserRole', role_id: string, expire_at: string | null }, assigned_campaigns: Array<{ __typename: 'Campaign', id: string | null, name: string | null, artist: { __typename: 'Artist', name: string | null, spotify_id: string | null, facebook_id: string | null } | null }> | null } };


export const GetUserDocument = gql`
    query getUser($id: Int) {
  getUser(id: $id) {
    email
    first_name
    last_name
    id
    label_id
    space_id
    unit_id
    country_code
    is_external
    role {
      role_id
      expire_at
    }
    assigned_campaigns {
      id
      artist {
        name
        spotify_id
        facebook_id
      }
      name
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;